export function useRes(src: string) {
  return import.meta.env.PROD
    ? 'https://cdn.ogoto.co/res/' + src
    : new URL('../assets/img/' + src, import.meta.url).href
}
